import { render } from "./ConfigSysNotifications.vue?vue&type=template&id=dc33bc86&scoped=true"
import script from "./ConfigSysNotifications.vue?vue&type=script&lang=js"
export * from "./ConfigSysNotifications.vue?vue&type=script&lang=js"

import "./ConfigSysNotifications.vue?vue&type=style&index=0&id=dc33bc86&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc33bc86"]])

export default __exports__